import { render, staticRenderFns } from "./delRulesModal.vue?vue&type=template&id=cde5c7d2&scoped=true&"
import script from "./delRulesModal.vue?vue&type=script&lang=js&"
export * from "./delRulesModal.vue?vue&type=script&lang=js&"
import style0 from "./delRulesModal.vue?vue&type=style&index=0&id=cde5c7d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cde5c7d2",
  null
  
)

component.options.__file = "delRulesModal.vue"
export default component.exports